import ReactFinalForm from 'components/form/ReactFinalForm';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { IRegionalRate } from 'interfaces';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';

interface RegionalRateFormProps {
  regionalRate: IRegionalRate;
  onSubmit: any;
}

export const RegionalRateForm = (props: RegionalRateFormProps) => {
  const { t } = useTranslation();
  const { regionalRate, onSubmit } = props;

  return (
    <div>
      {regionalRate && (
        <ReactFinalForm onSubmit={onSubmit} edit={!!regionalRate.id}>
          <div className="flex flex-wrap">
            <div className="w-full md:w-1/2 p-0 md:pr-2 mb-4">
              <IdentityField
                name="code"
                component={TextFieldAdapter}
                initialValue={regionalRate.code}
                label={t('global.code')}
                type="text"
              />
            </div>
            <div className="w-full md:w-1/2 p-0 md:pl-2">
              <IdentityField
                name="rate"
                component={TextFieldAdapter}
                initialValue={regionalRate.rate}
                label={t('entities.regional_rate.rate')}
                type="text"
              />
            </div>
            <div className="w-full ">
              <IdentityField
                name="description"
                component={TextFieldAdapter}
                initialValue={regionalRate.description}
                label={t('global.description')}
                type="text"
              />
            </div>
          </div>
        </ReactFinalForm>
      )}
    </div>
  );
};

export default RegionalRateForm;
